import React from 'react';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, Workflow_Evidence_Path } from '../../Server'
import axios from 'axios';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
// import tempimg from '../../assets/images/gailLogo.png'
import swal from 'sweetalert';

var tempimg = ud ? ud.cooperate_logo : "";
class ReportWorkflow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            UserInfo: {},
            TastList: []
        }
    }
    componentDidMount() {
        if (sessionStorage.getItem('User_reports_info') == null || sessionStorage.getItem('User_reports_info') == undefined || sessionStorage.getItem('User_reports_info') === "") {
            window.location.href = '/create/userlistreport'
            return
        }
        if (sessionStorage.getItem('report_info_version_siteadmin') == null || sessionStorage.getItem('report_info_version_siteadmin') == undefined || sessionStorage.getItem('report_info_version_siteadmin') === "") {
            window.location.href = '/create/userlistreport'
            return
        }
        this.fetch_aligned_workflow();
    }


    fetch_aligned_workflow = () => {
        var data = {
            user_id: JSON.parse(sessionStorage.getItem('User_reports_info')).login_id,
            workflow_id: JSON.parse(sessionStorage.getItem('report_info_session_siteadmin')).workflow_id,
            version_id: JSON.parse(sessionStorage.getItem('report_info_version_siteadmin')).version_id,
            id: JSON.parse(sessionStorage.getItem('report_info_version_siteadmin')).id
        }
        // var data = {
        //     workflow_id: "1",
        //     user_id: "8",
        //     version_id: "1"
        // }
        var arr = []
        var tempIndex = 1;
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/workflowFetchResponse`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.responses_Tasks.length > 0) {
                        response.data.responses_Tasks.map((list, index) => {
                            if (list.option_type == "M") {
                                arr.push(Object.assign(response.data.responses_Tasks[index], { sn: tempIndex }))
                                tempIndex = tempIndex + 1;
                            } else {
                                arr.push(Object.assign(response.data.responses_Tasks[index], { sn: "" }))
                            }

                        })
                        _this.setState({ TastList: arr, UserInfo: response.data.responses_main, message: arr.length > 0 ? "" : "No Record Found" })
                    }
                }else{
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.fetch_aligned_workflow();
                        }
                    })
                }

            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }

    CreatePdf = (e) => {
        window.print()
    }

    CreatePdf1 = () => {
        
         html2canvas( document.querySelector("#divToPrint") , { useCORS: true, scale:2})
            .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF();
                pdf.addImage(imgData, "JPEG", 15,15,180,0);
                pdf.save("Report.pdf");
            });

    }

    render() {

        return (
            <div>
                <canvas style={{ display: "none" }} id="my_canvas_id"></canvas>
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">

                          <a href="#" >
                                <button className="btn btn-primary btn-lg active" onClick={this.CreatePdf}>Download PDF</button>
                          </a>

                            {/* <h4 className="xp-page-title">Report</h4> */}
                            {/* <a href={`${SERVER_IP}/pdf/${this.state.UserInfo.pdf_name}`} download={this.state.UserInfo.pdf_name} target="_blank">
                                <button className="btn btn-primary btn-lg active" onClick={this.CreatePdf}>Download PDF</button>
                            </a> */}
                        </div>
                        
                        <div className="col-md-6 col-lg-6">
                            <div className="xp-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i className="icon-home"></i></a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/userlistreport"}>User List</a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/alignedworkflowsiteadmin"}>Aligned Workflow</a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/alignedsessionsiteadmin"}>Session</a></li>

                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar ">
                    <div id="divToPrint1">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card m-b-30">
                                    {/* <div className="card-header">
                                    <h5 className="card-title text-black mb-0">MCQ Library List</h5>
                                </div> */}

                                    <div className="card-body">
                                        {this.state.TastList.length === 0 ?
                                            this.state.message === "" ?

                                                // loader
                                                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                                // loader-end
                                                :
                                                <div className="message-no-record"> {this.state.message} </div>

                                            : null}
                                      
                                      <div id="divToPrint">
                                        <div className="u-info">

                                            <h3 className="mb-3 text text-capitalize">GAIL (India) Ltd.</h3>
                                            <hr></hr>
                                            <div className="u-wrapper">
                                                <figure className="u-pic-holder large" size="large">
                                                    <img src={tempimg} />
                                                </figure>
                                                <div className="u-info-holder">
                                                    <ul className="m-0 p-0 ml-2">
                                                        <li>
                                                            <div className="title">Site Name <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.site_name}</div>
                                                        </li>

                                                        <li>
                                                            <div className="title">Workflow Name <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.workflow_name}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Workflow ID <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.workflow_unique_id}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Version <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.version_name}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Start Date <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.startDate}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">End Date <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.endDate}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Completion %  <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.complete_percentage}% </div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Done By <span>:</span></div>
                                                            <div className="info">{this.state.UserInfo.name}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-striped table-bordered sire-table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">S.No</th>
                                                    <th className="text-left">Step</th>
                                                    {/* <th className="text-center">Status</th> */}
                                                    <th className="text-left">Ideal</th>
                                                    <th className="text-left">Response</th>
                                                    <th>Evidence</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.TastList.map((list, index) =>
                                                    <tr>
                                                        <td className="text-center"><p>{list.sn != "" ? list.sn : <i className="fa fa-dot-circle-o" aria-hidden="true"></i>}</p></td>
                                                        <td className="text-left">
                                                            <div className="mb-2">
                                                                {
                                                                    list.task_type != 3 ?
                                                                        list.skip == 0 ?
                                                                            <span className="badge badge-warning" data-toggle="tooltip" title="Skip"><i className="fa fa-mail-forward"></i> Skip</span>
                                                                            :
                                                                            list.task_type == 2 ?
                                                                                Number(list.response_ideal.split("-")[0]) < Number(list.response_perfomed) && Number(list.response_ideal.split("-")[1]) > Number(list.response_perfomed) ?
                                                                                    <span className="badge badge-success" data-toggle="tooltip" title="Success"><i className="mdi mdi-check-decagram"></i> Healthy</span>
                                                                                    :
                                                                                    <span className="badge badge-danger" data-toggle="tooltip" title="Warning"><i className="fa fa-warning"></i> Unhealthy</span>
                                                                                :

                                                                                list.response_perfomed === list.response_ideal ?
                                                                                    <span className="badge badge-success" data-toggle="tooltip" title="Success"><i className="mdi mdi-check-decagram"></i> Healthy</span>
                                                                                    :
                                                                                    <span className="badge badge-danger" data-toggle="tooltip" title="Warning"><i className="fa fa-warning"></i> Unhealthy</span>
                                                                        : ""
                                                                }

                                                            </div>
                                                            <div className="step-q">
                                                                {list.task_type == 1 ?
                                                                    <span className="mr-2" data-toggle="tooltip" title="MCQ"><i className="fa fa-th-list"></i></span>
                                                                    : null}
                                                                {list.task_type == 2 ?
                                                                    <span className="mr-2" data-toggle="tooltip" title="Range"><i className="fa fa-sort-numeric-asc"></i></span>
                                                                    : null}
                                                                {list.task_type == 3 ?
                                                                    <span className="mr-2" data-toggle="tooltip" title="Parent Child"><i className="fa fa-sitemap"></i></span>
                                                                    : null}
                                                                <p>
                                                                    {list.question}
                                                                </p>
                                                            </div>
                                                        </td>

                                                        <td className="text-left"><p>{list.response_ideal == "null" ? "" : list.response_ideal}</p></td>
                                                        <td className="text-left"><p> {list.skip == 0 && list.task_type != 3 ?
                                                            <b className="text-warning">Not Performed</b> : list.response_perfomed == "null" || list.response_perfomed == "" ?
                                                                "" :
                                                                list.response_perfomed === list.response_ideal ?
                                                                    <span data-toggle="tooltip" title="Success"> {list.response_perfomed}</span>
                                                                    :
                                                                    <span data-toggle="tooltip" title="Warning"> {list.response_perfomed}</span>}</p>
                                                        </td>
                                                        <td>

                                                            {list.evidence == "null" || list.evidence == "" ?
                                                                <b>N/A</b>
                                                                :
                                                                <figure>
                                                                    <SimpleReactLightbox>

                                                                        <SRLWrapper>
                                                                            <a href={`${SERVER_IP}/evidence/${list.evidence}`} data-attribute="SRL">
                                                                                <img src={`${SERVER_IP}/evidence/${list.evidence}`} style={{ width: "100%" }} />
                                                                            </a>
                                                                        </SRLWrapper>
                                                                    </SimpleReactLightbox>
                                                                </figure>
                                                            }
                                                        </td>

                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                     </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ReportWorkflow